import React from 'react';
import { Form, DatePicker } from 'ui/components';
import { formatDate } from 'utilities/common';

const initialState = {
  airplane: '',
  code_smu: '',
  no_manifest: '',
  date: {
    default: new Date(),
    formatted: formatDate(new Date(), 'YYYY-MM-DD'),
  },
  date_time: '',
  etd: {
    default: new Date(),
    formatted: formatDate(new Date(), 'YYYY-MM-DD'),
  },
  etd_time: '',
};

export const FormAir = ({ onValueChange, initialValue, errors }) => {
  const [
    { airplane, code_smu, no_manifest, date, etd, date_time, etd_time },
    setState,
  ] = React.useState(initialState);

  React.useEffect(() => {
    const value = {
      airplane,
      code_smu,
      no_manifest,
      date,
      etd,
      date_time,
      etd_time,
    };
    onValueChange(value);
  }, [airplane, code_smu, no_manifest, date, etd, date_time, etd_time]);

  React.useEffect(() => {
    if (!initialValue) return;

    setState((prevState) => ({
      ...prevState,
      airplane: initialValue?.airplane,
      code_smu: initialValue?.code_smu,
      no_manifest: initialValue?.no_manifest,
      date: {
        default: new Date(initialValue?.date),
        formatted: formatDate(initialValue?.date, 'YYYY-MM-DD'),
      },
      date_time: formatDate(initialValue?.date, 'HH:mm'),
      etd: {
        default: new Date(initialValue?.etd),
        formatted: formatDate(initialValue?.etd, 'YYYY-MM-DD'),
      },
      etd_time: formatDate(initialValue?.etd, 'HH:mm'),
    }));
  }, [initialValue]);

  return (
    <div className="">
      <div className="pt-3">
        <div className="row">
          <div className="col-md-6">
            <Form.Input
              value={airplane}
              onChange={(e) =>
                setState((prevState) => ({
                  ...prevState,
                  airplane: e.target.value,
                }))
              }
              type="text"
              label="Airplane"
            />
          </div>
          <div className="col-md-6">
            <Form.Input
              required
              value={code_smu}
              onChange={(e) =>
                setState((prevState) => ({
                  ...prevState,
                  code_smu: e.target.value,
                }))
              }
              type="text"
              label="Code SMU"
              error={errors?.code_smu}
            />
          </div>
          <div className="col-md-6">
            <Form.Input
              value={no_manifest}
              onChange={(e) =>
                setState((prevState) => ({
                  ...prevState,
                  no_manifest: e.target.value,
                }))
              }
              type="text"
              label="No. Manifest"
            />
          </div>

          <div className="col-md-12">
            <div className="row">
              <div className="col-md-8 col-7">
                <div className="mb-3">
                  <label className="form-label fs-8">
                    Tanggal Keberangkatan
                  </label>
                  <div
                    className={
                      errors['air_freight.etd']
                        ? 'border border-danger rounded'
                        : ''
                    }
                  >
                    <DatePicker
                      type="normal"
                      value={date?.default || null}
                      format="dd/MM/yyyy"
                      onChange={(d) =>
                        setState((prevState) => ({
                          ...prevState,
                          date: {
                            default: d,
                            formatted: formatDate(d, 'YYYY-MM-DD'),
                          },
                        }))
                      }
                      isShowTrigger
                    />
                  </div>
                  {errors['air_freight.date'] && (
                    <div
                      className="invalid-feedback"
                      style={{ display: 'block' }}
                    >
                      {errors['air_freight.date']}
                    </div>
                  )}
                </div>
              </div>
              <div className="col-md-4 col-5">
                <Form.Time
                  label="Jam Keberangkatan"
                  value={date_time}
                  onChange={(e) =>
                    setState((prevState) => ({
                      ...prevState,
                      date_time: e,
                    }))
                  }
                  error={errors['air_freight.date']}
                />
              </div>
            </div>
          </div>

          <div className="col-md-12">
            <div className="row">
              <div className="col-md-8 col-7">
                <div className="mb-3">
                  <label className="form-label fs-8">
                    Tanggal Estimasi Tiba
                  </label>
                  <div
                    className={
                      errors['air_freight.etd']
                        ? 'border border-danger rounded'
                        : ''
                    }
                  >
                    <DatePicker
                      type="normal"
                      value={etd?.default}
                      format="dd/MM/yyyy"
                      onChange={(d) =>
                        setState((prevState) => ({
                          ...prevState,
                          etd: {
                            default: d,
                            formatted: formatDate(d, 'YYYY-MM-DD'),
                          },
                        }))
                      }
                      isShowTrigger
                    />
                  </div>
                  {errors['air_freight.etd'] && (
                    <div
                      className="invalid-feedback"
                      style={{ display: 'block' }}
                    >
                      {errors['air_freight.etd']}
                    </div>
                  )}
                </div>
              </div>
              <div className="col-md-4 col-5">
                <Form.Time
                  label="Jam Estimasi Tiba"
                  value={etd_time}
                  onChange={(e) =>
                    setState((prevState) => ({
                      ...prevState,
                      etd_time: e,
                    }))
                  }
                  error={errors['air_freight.etd']}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
